export const countries = {
  none: "Ninguno",
  argentina: "Argentina",
  bolivia: "Bolivia",
  brazil: "Brasil",
  chile: "Chile",
  colombia: "Colombia",
  ecuador: "Ecuador",
  paraguay: "Paraguay",
  peru: "Perú",
  uruguay: "Uruguay",
  venezuela: "Venezuela",
};
